import React from 'react'
import ProductDetail91 from './ProductDetail91'
import ProductDetail92 from './ProductDetail92'
import ProductDetail93 from './ProductDetail93'
import ProductDetail94 from './ProductDetail94'
import ProductDetail95 from './ProductDetail95'

function ProductDetail9() {
  return (
    <div>
      <ProductDetail91/>
      <ProductDetail92/>
      <ProductDetail93/>
      <ProductDetail94/>
      <ProductDetail95/>
    </div>
  )
}

export default ProductDetail9
